import { memo } from 'react';
import { useZoom } from '../ZoomContext';
import { useIsDarkMode } from '@/contexts/ThemeContext';

const HIVE_CONNECTION_RADIUS_METERS = 10;

function HiveConnectionRadius() {
  const { adjustedZoom } = useZoom();
  const isDarkMode = useIsDarkMode();
  const color = isDarkMode ? '#34D399' : '#10B981';

  return (
    <circle
      data-id="hive-connection-radius"
      r={HIVE_CONNECTION_RADIUS_METERS}
      fill={color}
      fillOpacity={isDarkMode ? 0.12 : 0.1}
      stroke={color}
      strokeOpacity={isDarkMode ? 0.5 : 0.4}
      strokeWidth={0.08 / adjustedZoom}
      strokeDasharray={`${0.3 / adjustedZoom} ${0.2 / adjustedZoom}`}
      style={{ pointerEvents: 'none' }}
    />
  );
}

export default memo(HiveConnectionRadius);
